"use client";

import MuxPlayer from "@mux/mux-player-react/lazy";
import { useInView } from "motion/react";
import { usePathname } from "next/navigation";
import { useRef } from "react";

export function VideoRenderer({ aspectRatio, muxPlaybackId }: { aspectRatio: string; muxPlaybackId: string }) {
	const pathname = usePathname();
	const ref = useRef<HTMLDivElement | null>(null);
	const isInView = useInView(ref, { amount: 0.2, initial: false, once: false });
	const isRealEstate = pathname === "/real-estate";
	return (
		<div className="w-full h-full relative overflow-hidden cursor-pointer" ref={ref}>
			<MuxPlayer
				accentColor="#525a4a"
				autoPlay={isRealEstate ? false : "muted"}
				className={`${isRealEstate ? "real-estate" : ""} min-h-full min-w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2`}
				loading="viewport"
				loop
				muted={!isRealEstate}
				paused={isRealEstate ? undefined : !isInView}
				playbackId={muxPlaybackId}
				style={{ aspectRatio, fontSize: 0 }}
				theme="minimal"
			/>
		</div>
	);
}
